import axios from 'axios';

export const deleteFolder = async (folderId: string) => {
  await axios.post(`/asset/folder/${folderId}`);
};
